import { render } from "./AddonViewFullText.vue?vue&type=template&id=75b55096&scoped=true&ts=true"
import script from "./AddonViewFullText.vue?vue&type=script&lang=ts"
export * from "./AddonViewFullText.vue?vue&type=script&lang=ts"

import "./AddonViewFullText.vue?vue&type=style&index=0&id=75b55096&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75b55096"]])

export default __exports__